module.exports = __webpack_public_path__ + "img/Number.1836164.png";